import { date, integer, jsonb, pgTable, text, varchar } from 'drizzle-orm/pg-core';
import { id, timestamps } from './_shared';

export const profileAudits = pgTable('profile_audits', {
  id: id(),
  userId: text('user_id').notNull(),
  surface: varchar('surface', { length: 24 }).notNull(),
  recommendations: jsonb('recommendations'),
  appliedAt: date('applied_at'),
  beforeSnapshot: text('before_snapshot'),
  afterSnapshot: text('after_snapshot'),
  ...timestamps,
});

export const profileMetrics = pgTable('profile_metrics', {
  id: id(),
  userId: text('user_id').notNull(),
  surface: varchar('surface', { length: 24 }).notNull(),
  weekStarting: date('week_starting').notNull(),
  inmailCount: integer('inmail_count'),
  profileViews: integer('profile_views'),
  appearancesInSearch: integer('appearances_in_search'),
  variantSnapshot: jsonb('variant_snapshot'),
  ...timestamps,
});
